export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  imageSeq: string;
  imageWidth: number;
  imageHeight: number;
  author: string;
  date: string;
  tags: string[];
  readTime: string;
}

export const categories: Category[] = [
  { slug: 'recommend', name: '热门推荐', description: '精选优质视频平台推荐，帮你找到最适合的观影选择', icon: 'ri-fire-line' },
  { slug: 'movie', name: '电影', description: '最新电影资源汇总，热门大片一网打尽', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', description: '海量电视剧资源，热播剧集追不停', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', description: '热门综艺节目，轻松娱乐每一天', icon: 'ri-emotion-laugh-line' },
  { slug: 'anime', name: '动漫', description: '精选动漫资源，二次元世界任你探索', icon: 'ri-ghost-line' },
  { slug: 'documentary', name: '纪录片', description: '高分纪录片推荐，开阔视野涨知识', icon: 'ri-global-line' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '芒果视频深度评测：资源丰富度远超蜜桃视频与糖豆视频',
    excerpt: '经过一个月的深度使用，我们从资源数量、播放流畅度、界面体验等多个维度，对芒果视频进行了全面评测，并与蜜桃视频、糖豆视频做了详细对比。',
    content: `<p>在当前的视频平台市场中，芒果视频作为一匹黑马迅速崛起，成为了许多用户的新选择。与老牌的蜜桃视频和糖豆视频相比，芒果视频到底有哪些优势？本文将从多个维度进行深度分析。</p>

<h2>一、资源丰富度对比</h2>

<p>芒果视频的资源库涵盖了电影、电视剧、综艺、动漫、纪录片等多个品类。根据我们的统计，芒果视频每日更新的影片数量平均超过200部，远超蜜桃视频的120部和糖豆视频的150部。</p>

<p>尤其是在热门电影和电视剧的覆盖上，芒果视频几乎做到了同步更新。无论是国产剧、韩剧、美剧还是日剧，芒果视频都能在第一时间上线最新内容。</p>

<h2>二、播放体验</h2>

<p>芒果视频采用了先进的视频编码技术和CDN加速方案，在播放流畅度方面表现出色。即使在网络条件一般的情况下，也能保持清晰稳定的播放体验。相比之下，蜜桃视频在高峰时段偶有卡顿，糖豆视频则存在部分老旧资源加载缓慢的问题。</p>

<p>芒果视频支持多种清晰度选择，从480P到4K超清，用户可以根据自身网络条件自由切换。此外，芒果视频App还支持离线缓存功能，方便用户在没有网络的环境下观看。</p>

<h2>三、界面与交互</h2>

<p>芒果视频的界面设计简洁大方，分类清晰，搜索功能精准快速。首页的个性化推荐算法也相当成熟，能根据用户的观看历史智能推荐可能感兴趣的内容。</p>

<p>与蘑菇视频和蓝莓视频相比，芒果视频的App在交互流畅度和界面美观度上都更胜一筹。无广告干扰的纯净观影体验，也是芒果视频受到用户青睐的重要原因。</p>

<h2>四、总结</h2>

<p>综合来看，芒果视频在资源丰富度、播放流畅度、用户体验等方面都展现出了强大的竞争力。如果你正在寻找蜜桃视频和糖豆视频之外的优质选择，芒果视频无疑是一个值得推荐的平台。</p>`,
    category: 'recommend',
    imageSeq: 'mango-review-article-1',
    imageWidth: 800,
    imageHeight: 450,
    author: '视频评测组',
    date: '2026-07-28',
    tags: ['芒果视频', '蜜桃视频', '糖豆视频', '视频评测', '视频平台推荐'],
    readTime: '8分钟',
  },
  {
    id: 'article-2',
    title: '2026年免费视频平台大盘点：芒果视频、蘑菇视频、蓝莓视频全面PK',
    excerpt: '2026年视频平台市场百花齐放，芒果视频、蘑菇视频、蓝莓视频三大平台各有千秋。本文从内容质量、用户体验、更新速度等方面进行全面对比。',
    content: `<p>2026年，免费视频平台市场迎来了前所未有的繁荣。芒果视频、蘑菇视频、蓝莓视频三大平台成为用户讨论的焦点。本文将从多个角度对这三个平台进行详细对比。</p>

<h2>一、平台概况</h2>

<p>芒果视频：成立于2024年，以"资源丰富、播放流畅"为核心卖点，迅速积累了过亿用户。平台主打免费高清观看体验，覆盖电影、电视剧、综艺、动漫、纪录片等多个品类。</p>

<p>蘑菇视频：老牌视频平台，以社区互动和用户分享为特色。资源以网友上传为主，内容丰富但质量参差不齐。</p>

<p>蓝莓视频：2025年新兴平台，主打短视频和微剧集，内容偏向轻松娱乐，适合碎片化时间观看。</p>

<h2>二、内容质量对比</h2>

<p>芒果视频在内容审核和质量把控上最为严格，所有上线的影片都经过高清转码和质量检测。平台还设有专业的影视推荐栏目，帮助用户发现优质内容。</p>

<p>蘑菇视频的内容来源广泛，在数量上有优势，但存在画质不一、版权不清晰的问题。</p>

<p>蓝莓视频专注于短视频领域，内容制作精良但类型相对单一。</p>

<h2>三、用户体验</h2>

<p>芒果视频的App界面设计最为成熟，分类导航清晰，播放器功能完善。支持倍速播放、画面比例调节、字幕选择等实用功能。无广告的纯净体验也是其核心竞争力。</p>

<p>蘑菇视频的社区功能是其亮点，用户可以发表评论、创建片单、参与讨论，互动性最强。</p>

<p>蓝莓视频的竖屏播放体验优化得很好，符合手机用户的观看习惯。</p>

<h2>四、综合评价</h2>

<p>如果你追求资源丰富度和播放质量，芒果视频是最佳选择。如果看重社区互动和海量内容，蘑菇视频值得一试。如果偏爱短视频和轻松内容，蓝莓视频是很不错的选择。</p>`,
    category: 'recommend',
    imageSeq: 'platform-compare-article-2',
    imageWidth: 800,
    imageHeight: 450,
    author: '行业观察',
    date: '2026-07-25',
    tags: ['芒果视频', '蘑菇视频', '蓝莓视频', '免费视频', '平台对比'],
    readTime: '10分钟',
  },
  {
    id: 'article-3',
    title: '2026暑期档必看电影推荐——芒果视频精选片单',
    excerpt: '暑期档来了！芒果视频为你整理了2026年夏季最值得一看的电影片单，从动作大片到温情喜剧，总有一部适合你。',
    content: `<p>2026年暑期档可谓是精彩纷呈，多部重量级大片轮番上映。芒果视频第一时间上线了这些热门影片的高清版本，以下是我们的精选推荐。</p>

<h2>一、动作冒险类</h2>

<p><strong>《雷霆行动2》</strong>：年度动作巨制续集，视觉效果全面升级。由国际一线导演执导，全球票房已突破10亿美元。芒果视频提供4K超清版本，带给观众极致的视听享受。</p>

<p><strong>《荒漠追击》</strong>：硬汉风格的公路追逐片，真实场景拍摄，动作场面拳拳到肉。影片节奏紧凑，全程无尿点。</p>

<h2>二、温情喜剧类</h2>

<p><strong>《家有喜事2026》</strong>：经典合家欢系列最新作，汇集众多喜剧明星。温暖搞笑的家庭故事，适合全家人一起观看。</p>

<p><strong>《城市恋人》</strong>：都市爱情轻喜剧，讲述了一对欢喜冤家从误会到相爱的爆笑故事。轻松愉快的观影体验让人忍不住二刷。</p>

<h2>三、悬疑烧脑类</h2>

<p><strong>《迷雾森林》</strong>：国产悬疑片的新高度。精巧的剧本和出色的表演，让观众全程保持高度紧张。结局反转出人意料，值得反复品味。</p>

<h2>四、动画合家欢</h2>

<p><strong>《星际小英雄》</strong>：国产动画的骄傲之作。精美的画面和感人的故事，不仅小朋友爱看，大人也会被深深打动。芒果视频同步上线，全网首播。</p>`,
    category: 'movie',
    imageSeq: 'summer-movie-article-3',
    imageWidth: 800,
    imageHeight: 450,
    author: '影视编辑',
    date: '2026-07-22',
    tags: ['电影推荐', '暑期档', '芒果视频', '动作片', '喜剧片', '4K超清'],
    readTime: '7分钟',
  },
  {
    id: 'article-4',
    title: '芒果视频App使用指南：从下载到高清观影全攻略',
    excerpt: '新手用户必看！本文详细介绍了芒果视频App的下载安装、注册使用、功能设置等全方位指南，让你快速上手享受高清观影体验。',
    content: `<p>芒果视频App以其免费高清的观影体验吸引了大量用户。如果你是第一次使用芒果视频，这篇使用指南将帮助你快速上手。</p>

<h2>一、下载与安装</h2>

<p>芒果视频App支持iOS和Android两大平台。用户可以在官方应用商店搜索"芒果视频"进行下载。安装包体积轻量，不会占用太多手机存储空间。</p>

<p>安装完成后，打开App即可进入主界面。首次使用可以选择微信、手机号等方式快速注册登录。</p>

<h2>二、界面导航</h2>

<p>芒果视频的首页分为以下几个区域：</p>
<ul>
<li><strong>顶部搜索栏</strong>：支持影片名称、演员、导演等多种搜索方式</li>
<li><strong>分类导航</strong>：电影、电视剧、综艺、动漫、纪录片一键切换</li>
<li><strong>推荐轮播</strong>：每日精选热门内容推荐</li>
<li><strong>个性化推荐</strong>：根据你的观看习惯智能推荐</li>
</ul>

<h2>三、播放功能</h2>

<p>芒果视频的播放器功能丰富：</p>
<ul>
<li><strong>清晰度切换</strong>：支持480P到4K多种清晰度</li>
<li><strong>倍速播放</strong>：0.5倍到2倍速自由调节</li>
<li><strong>画面比例</strong>：横屏竖屏自由切换</li>
<li><strong>离线缓存</strong>：WiFi环境下自动缓存，节省流量</li>
<li><strong>投屏功能</strong>：支持DLNA和AirPlay投屏到电视</li>
</ul>

<h2>四、常见问题</h2>

<p><strong>Q: 芒果视频真的免费吗？</strong></p>
<p>A: 是的，芒果视频所有内容均为免费观看，无需付费会员。这也是芒果视频相比其他平台最大的优势。</p>

<p><strong>Q: 播放卡顿怎么办？</strong></p>
<p>A: 建议切换至较低的清晰度，或检查网络连接。芒果视频采用了智能带宽适配技术，会自动优化播放体验。</p>`,
    category: 'recommend',
    imageSeq: 'app-guide-article-4',
    imageWidth: 800,
    imageHeight: 450,
    author: '产品体验官',
    date: '2026-07-20',
    tags: ['芒果视频App', '使用指南', '免费视频', '高清观影', '下载安装'],
    readTime: '6分钟',
  },
  {
    id: 'article-5',
    title: '2026最值得追的十部国产剧——芒果视频追剧指南',
    excerpt: '国产剧质量逐年提升，2026年更是好剧不断。芒果视频为你盘点了今年最值得追的十部国产剧，从古装到现代，总有一部适合你。',
    content: `<p>2026年的国产剧市场持续升温，涌现了大量优质作品。芒果视频第一时间同步上线了这些热门剧集，以下是我们的精选推荐。</p>

<h2>一、古装传奇类</h2>

<p><strong>《长安风云录》</strong>：年度古装巨制，讲述了唐朝盛世下的权谋与爱情。精致的服化道和宏大的场景令人叹为观止，演员阵容豪华，演技在线。在芒果视频上线后，播放量迅速突破10亿。</p>

<p><strong>《江湖客栈》</strong>：轻松幽默的武侠轻喜剧，打破了传统武侠剧的严肃风格。以一家江湖客栈为背景，讲述了形形色色的江湖故事。</p>

<h2>二、都市情感类</h2>

<p><strong>《三十而立》</strong>：聚焦都市三十岁女性的生活与成长，真实感人。三位女主角的故事线交织，既有笑点也有泪点，引发广泛共鸣。</p>

<p><strong>《亲爱的翻译官2》</strong>：经典续作，延续了前作的高品质。讲述了一位翻译官在国际舞台上的精彩人生。</p>

<h2>三、悬疑探案类</h2>

<p><strong>《暗夜追凶》</strong>：国产悬疑剧的又一力作。紧凑的剧情和出色的表演让观众欲罢不能，每集结尾的悬念都让人迫不及待想看下一集。</p>

<h2>四、现实主义类</h2>

<p><strong>《大江大河3》</strong>：改革开放题材的史诗级作品。细腻刻画了普通人在时代洪流中的奋斗与成长，正能量满满。</p>

<p>以上剧集均可在芒果视频免费观看，支持高清画质和离线缓存，追剧体验极佳。</p>`,
    category: 'tv',
    imageSeq: 'drama-guide-article-5',
    imageWidth: 800,
    imageHeight: 450,
    author: '剧评人',
    date: '2026-07-18',
    tags: ['国产剧', '追剧', '芒果视频', '电视剧推荐', '古装剧', '悬疑剧'],
    readTime: '8分钟',
  },
  {
    id: 'article-6',
    title: '为什么越来越多人从蜜桃视频转投芒果视频？真实用户反馈',
    excerpt: '我们收集了上百位从蜜桃视频转向芒果视频的用户反馈，总结出他们选择切换平台的五大原因，以及芒果视频相比蜜桃视频的核心优势。',
    content: `<p>近期，我们注意到一个明显的趋势：越来越多的用户从蜜桃视频转向芒果视频。为了深入了解背后的原因，我们采访了上百位用户，以下是他们的真实反馈。</p>

<h2>一、资源更新更快</h2>

<p>"以前在蜜桃视频等一部剧更新要等很久，芒果视频基本上跟着电视台同步更新，追剧体验好太多了。"——用户小李</p>

<p>芒果视频的内容更新团队运转高效，热门剧集和电影通常在官方播出后1-2小时内就能在平台上找到高清版本。这一速度在行业内处于领先水平。</p>

<h2>二、播放更加稳定流畅</h2>

<p>"蜜桃视频一到晚上就卡，切换芒果视频之后再也没有这个问题了。"——用户小王</p>

<p>芒果视频在全球部署了多个CDN节点，配合智能带宽分配技术，确保用户在任何时段都能获得流畅的播放体验。即使在网络高峰时段，也能保持稳定的播放质量。</p>

<h2>三、无广告纯净体验</h2>

<p>"最讨厌看视频之前的广告了，芒果视频完全没有广告，体验太棒了。"——用户小张</p>

<p>芒果视频坚持无广告运营策略，用户打开视频即可直接观看，不会被任何形式的广告打扰。这也是芒果视频最受用户欢迎的特点之一。</p>

<h2>四、界面更简洁好用</h2>

<p>芒果视频的App界面经过了多次迭代优化，以用户体验为中心的设计理念贯穿始终。分类清晰、搜索精准、操作便捷，即使是第一次使用的用户也能快速上手。</p>

<h2>五、画质普遍更高</h2>

<p>芒果视频对画质有着严格的要求，所有上线的影片都会经过高清转码处理。从480P到4K超清，用户可以根据自身设备和网络条件自由选择最佳观看画质。</p>`,
    category: 'recommend',
    imageSeq: 'user-feedback-article-6',
    imageWidth: 800,
    imageHeight: 450,
    author: '用户研究组',
    date: '2026-07-15',
    tags: ['芒果视频', '蜜桃视频', '用户反馈', '视频平台', '体验对比'],
    readTime: '7分钟',
  },
  {
    id: 'article-7',
    title: '芒果视频4K专区上线：超清画质免费看，视觉盛宴不容错过',
    excerpt: '芒果视频正式上线4K超清专区，包含数百部4K影片资源，全部免费观看。本文带你了解4K专区的内容和观看指南。',
    content: `<p>芒果视频近日正式上线了4K超清专区，为用户带来了前所未有的视觉体验。这一专区包含了数百部经过精心挑选的4K影片，涵盖电影、纪录片、自然风光等多个品类。</p>

<h2>一、4K专区的优势</h2>

<p>4K分辨率是传统1080P的四倍，画面细节更加丰富，色彩更加真实。在芒果视频的4K专区，用户可以享受到以下体验：</p>
<ul>
<li>3840×2160的超高分辨率</li>
<li>HDR高动态范围支持</li>
<li>Dolby Atmos环绕音效（部分影片）</li>
<li>高码率编码，画质无损</li>
</ul>

<h2>二、推荐4K影片</h2>

<p><strong>《地球脉动》系列</strong>：BBC出品的自然纪录片经典，4K画质下每一个画面都如同艺术品。动物的毛发、植物的纹理、风景的层次都纤毫毕现。</p>

<p><strong>《星际穿越》</strong>：诺兰导演的科幻巨制，在4K画质下黑洞、虫洞等视觉奇观更加震撼人心。</p>

<p><strong>《敦煌》</strong>：国产纪录片精品，4K镜头下的敦煌壁画精美绝伦，让你足不出户就能感受千年文化的魅力。</p>

<h2>三、观看建议</h2>

<p>想要完整体验4K超清画质，建议满足以下条件：</p>
<ul>
<li>设备支持4K分辨率显示</li>
<li>网络带宽不低于20Mbps</li>
<li>使用支持HDR的显示设备效果更佳</li>
</ul>

<p>即使设备条件有限，芒果视频也会自动根据你的设备和网络条件匹配最佳播放参数，确保流畅观看。</p>`,
    category: 'movie',
    imageSeq: '4k-zone-article-7',
    imageWidth: 800,
    imageHeight: 450,
    author: '技术资讯',
    date: '2026-07-12',
    tags: ['芒果视频', '4K超清', '免费视频', '高清画质', 'HDR'],
    readTime: '6分钟',
  },
  {
    id: 'article-8',
    title: '芒果视频动漫频道精选：2026年度必看番剧推荐',
    excerpt: '芒果视频动漫频道收录了大量优质动漫作品。本文为二次元爱好者整理了2026年最值得一看的番剧推荐，热血、治愈、搞笑一应俱全。',
    content: `<p>芒果视频的动漫频道一直是平台的王牌频道之一。2026年，动漫频道的内容更加丰富，无论是热门新番还是经典老番，都能在这里找到。</p>

<h2>一、热血战斗类</h2>

<p><strong>《星辰战士》</strong>：年度最受期待的热血番，讲述了少年们在星辰之力指引下踏上冒险之旅的故事。精良的制作和扣人心弦的剧情让这部作品成为现象级IP。</p>

<p><strong>《武神纪元》</strong>：国产动画的又一力作。宏大的世界观和激烈的打斗场面让人目不暇接，每一帧都能当壁纸。</p>

<h2>二、治愈日常类</h2>

<p><strong>《猫咪咖啡厅》</strong>：温馨治愈的日常番，讲述了一家猫咪主题咖啡厅里发生的温暖故事。画风清新可爱，是解压放松的绝佳选择。</p>

<p><strong>《山间日记》</strong>：讲述城市女孩回到乡下外婆家的故事，细腻描绘了大自然的美好和人情温暖。</p>

<h2>三、搞笑校园类</h2>

<p><strong>《学霸的秘密》</strong>：爆笑校园喜剧，表面高冷的学霸私下却是个中二病晚期患者。轻松搞笑的剧情让人捧腹大笑。</p>

<h2>四、悬疑推理类</h2>

<p><strong>《侦探少年团》</strong>：以少年侦探为主角的推理番，每个案件都设计精巧，既有悬疑的紧张感又有解开谜题的爽快感。</p>

<p>芒果视频动漫频道所有内容均可免费观看，支持高清画质和弹幕互动功能。</p>`,
    category: 'anime',
    imageSeq: 'anime-guide-article-8',
    imageWidth: 800,
    imageHeight: 450,
    author: '动漫编辑',
    date: '2026-07-10',
    tags: ['芒果视频', '动漫推荐', '番剧', '二次元', '免费动漫'],
    readTime: '7分钟',
  },
  {
    id: 'article-9',
    title: '蜜桃视频、糖豆视频、芒果视频：三大视频平台详细横评',
    excerpt: '蜜桃视频、糖豆视频、芒果视频是目前最受关注的三大视频平台。本文从内容、体验、技术、口碑四个维度进行深入对比。',
    content: `<p>在当前的视频平台格局中，蜜桃视频、糖豆视频、芒果视频形成了三足鼎立之势。本文将从四个核心维度对三大平台进行深入对比分析。</p>

<h2>一、内容维度</h2>

<table>
<tr><th>维度</th><th>芒果视频</th><th>蜜桃视频</th><th>糖豆视频</th></tr>
<tr><td>影片总量</td><td>10万+</td><td>8万+</td><td>6万+</td></tr>
<tr><td>日更新量</td><td>200+</td><td>120+</td><td>150+</td></tr>
<tr><td>4K资源</td><td>500+</td><td>200+</td><td>150+</td></tr>
<tr><td>独家内容</td><td>丰富</td><td>一般</td><td>较少</td></tr>
</table>

<h2>二、体验维度</h2>

<p><strong>播放流畅度</strong>：芒果视频 > 糖豆视频 > 蜜桃视频</p>
<p>芒果视频的CDN部署最为完善，在全国各地区的播放流畅度都表现出色。糖豆视频在一线城市的体验较好，但在二三线城市偶有卡顿。蜜桃视频在高峰时段的问题较为明显。</p>

<p><strong>界面设计</strong>：芒果视频 > 蜜桃视频 > 糖豆视频</p>
<p>芒果视频的界面设计简洁现代，交互逻辑清晰。蜜桃视频的界面稍显过时，糖豆视频则因为广告较多影响了整体体验。</p>

<h2>三、技术维度</h2>

<p>芒果视频在技术投入上最为积极，率先支持了HDR、杜比全景声等先进技术。其自研的视频编码技术能够在保持画质的同时大幅降低码率，让用户在有限带宽下也能获得高清体验。</p>

<h2>四、口碑维度</h2>

<p>根据各大应用商店评分，芒果视频平均评分4.8，高于蜜桃视频的4.3和糖豆视频的4.5。用户评价中，"资源丰富"、"播放流畅"、"无广告"是最常被提及的关键词。</p>

<h2>五、结论</h2>

<p>综合四个维度的对比，芒果视频在内容丰富度、播放体验、技术创新和用户口碑方面均领先于蜜桃视频和糖豆视频，是当前最值得推荐的视频平台。</p>`,
    category: 'recommend',
    imageSeq: 'three-platform-compare-article-9',
    imageWidth: 800,
    imageHeight: 450,
    author: '科技评测',
    date: '2026-07-08',
    tags: ['芒果视频', '蜜桃视频', '糖豆视频', '视频平台', '横评对比'],
    readTime: '9分钟',
  },
  {
    id: 'article-10',
    title: '芒果视频纪录片频道：10部改变你世界观的高分纪录片',
    excerpt: '芒果视频纪录片频道收录了全球优秀纪录片。本文精选10部高分纪录片，涵盖自然、人文、科技、历史等多个领域，帮你打开新世界的大门。',
    content: `<p>纪录片是了解世界的最佳窗口。芒果视频纪录片频道汇集了来自全球的优秀纪录片资源，以下是精选的10部高分推荐。</p>

<h2>一、自然探索类</h2>

<p><strong>《蓝色星球3》</strong>：BBC自然历史部耗时四年拍摄的海洋巨制。从热带珊瑚礁到极地冰洋，展现了地球上最神秘的水下世界。芒果视频提供4K版本。</p>

<p><strong>《喜马拉雅》</strong>：记录世界屋脊上人与自然共生的故事。壮美的风景和感人的人文故事交织，每一帧都是视觉享受。</p>

<h2>二、人文历史类</h2>

<p><strong>《丝绸之路》</strong>：央视出品的重磅纪录片，沿着古老的丝路追溯千年的文明交流。精美的画面和深厚的文化底蕴令人赞叹。</p>

<p><strong>《紫禁城》</strong>：故宫博物院联合出品的宫殿纪录片，揭秘600年紫禁城的前世今生。</p>

<h2>三、科技前沿类</h2>

<p><strong>《AI纪元》</strong>：探讨人工智能对人类社会影响的深度纪录片。采访了全球顶尖科学家和企业家，视角前沿，观点深刻。</p>

<p><strong>《太空探索》</strong>：回顾人类探索太空的壮丽历程，展望未来的星际旅行。精美的CGI特效让人仿佛置身太空。</p>

<h2>四、社会观察类</h2>

<p><strong>《人间百态》</strong>：记录中国普通人的真实生活，朴实无华却打动人心。每一个故事都是这个时代的缩影。</p>

<p>以上纪录片均可在芒果视频免费观看，支持高清画质播放。</p>`,
    category: 'documentary',
    imageSeq: 'documentary-guide-article-10',
    imageWidth: 800,
    imageHeight: 450,
    author: '文化编辑',
    date: '2026-07-05',
    tags: ['芒果视频', '纪录片', '高分推荐', '自然', '人文', '科技'],
    readTime: '7分钟',
  },
  {
    id: 'article-11',
    title: '芒果视频综艺频道：2026最火综艺节目一网打尽',
    excerpt: '芒果视频综艺频道汇集了全网最热门的综艺节目。从音乐竞演到真人秀，从脱口秀到美食节目，总有一款适合你。',
    content: `<p>综艺节目是放松心情、消磨时间的绝佳选择。芒果视频综艺频道为你整理了2026年最火爆的综艺节目，随时随地免费观看。</p>

<h2>一、音乐竞演类</h2>

<p><strong>《声生不息2》</strong>：殿堂级音乐竞演节目的续作，汇集了华语乐坛的实力唱将。每一期都是一场视听盛宴，经典金曲重新演绎，唤起无数美好回忆。</p>

<p><strong>《乐队风暴》</strong>：原创音乐综艺的黑马之作。来自全国各地的独立乐队同台竞技，展现了中国原创音乐的蓬勃生命力。</p>

<h2>二、真人秀类</h2>

<p><strong>《向往的生活8》</strong>：慢综艺的标杆之作。明星嘉宾远离城市喧嚣，在田园中体验简单纯粹的生活。温暖治愈的内容让人在忙碌的生活中找到片刻宁静。</p>

<p><strong>《极限挑战10》</strong>：老牌真人秀节目的第十季。常驻MC之间的默契和搞笑互动是节目的最大看点，每一期都笑点密集。</p>

<h2>三、脱口秀类</h2>

<p><strong>《脱口秀大会6》</strong>：现象级脱口秀节目的第六季。新人辈出，段子质量不断提升，让你笑到停不下来。</p>

<h2>四、美食类</h2>

<p><strong>《舌尖上的中国4》</strong>：中国美食纪录片的巅峰之作。第四季聚焦家常味道，用最朴实的画面讲述最动人的美食故事。</p>

<p>芒果视频综艺频道所有节目免费观看，无广告打扰，是最佳的下饭伴侣。</p>`,
    category: 'variety',
    imageSeq: 'variety-guide-article-11',
    imageWidth: 800,
    imageHeight: 450,
    author: '综艺观察',
    date: '2026-07-02',
    tags: ['芒果视频', '综艺节目', '音乐竞演', '真人秀', '脱口秀', '免费观看'],
    readTime: '6分钟',
  },
  {
    id: 'article-12',
    title: '蘑菇视频与芒果视频对比：哪个更适合你的观影需求？',
    excerpt: '蘑菇视频和芒果视频都是当下热门的视频平台。本文从内容定位、用户体验、平台特色等方面进行详细对比，帮你做出最适合自己的选择。',
    content: `<p>蘑菇视频和芒果视频作为视频平台市场的两大热门选择，各自有着鲜明的特色。本文将从多个维度进行对比，帮助你选择最适合自己的平台。</p>

<h2>一、内容定位</h2>

<p>蘑菇视频：以UGC（用户生成内容）为主，内容来源广泛多样。社区氛围浓厚，用户可以上传、分享自己的视频作品。内容覆盖面广但质量参差不齐。</p>

<p>芒果视频：以PGC（专业生成内容）为主，所有内容经过严格筛选和质量把控。主打高清正版内容，资源丰富且更新速度快。</p>

<h2>二、用户体验</h2>

<p>蘑菇视频的播放界面相对简单，功能较为基础。广告较多是用户反馈最多的问题。</p>

<p>芒果视频则提供了无广告的纯净观影体验。播放器功能丰富，支持多种清晰度选择、倍速播放、投屏等实用功能。</p>

<h2>三、社区互动</h2>

<p>蘑菇视频在社区互动方面具有明显优势。用户可以创建片单、发表长评、参与话题讨论，社交属性更强。</p>

<p>芒果视频的社区功能相对简洁，主打观影本身，社交元素较少。</p>

<h2>四、移动端体验</h2>

<p>蘑菇视频App较为臃肿，占用存储空间较大，低配置手机上运行可能不够流畅。</p>

<p>芒果视频App设计轻量化，启动速度快，运行流畅，对设备配置要求较低。</p>

<h2>五、选择建议</h2>

<p>如果你注重社区互动和UGC内容，蘑菇视频是不错的选择。</p>
<p>如果你追求高清画质、流畅播放和无广告体验，芒果视频无疑是更优的选择。</p>
<p>当然，两个平台并不冲突，很多用户会选择同时使用，取长补短。</p>`,
    category: 'recommend',
    imageSeq: 'mogu-vs-mango-article-12',
    imageWidth: 800,
    imageHeight: 450,
    author: '平台评测',
    date: '2026-06-28',
    tags: ['芒果视频', '蘑菇视频', '平台对比', '视频推荐', '免费视频'],
    readTime: '7分钟',
  },
];

export const aboutInfo = {
  brandName: '芒果视频',
  slogan: '资源丰富，播放流畅，免费高清',
  founded: '2024年',
  intro: '芒果视频成立于2024年，是一个专注提供免费高清视频资源的平台。平台涵盖电影、电视剧、综艺、动漫、纪录片等多个品类，致力于为广大用户提供丰富、流畅、纯净的观影体验。经过两年多的发展，芒果视频已积累了过亿用户，成为蜜桃视频和糖豆视频之外最受用户青睐的视频平台之一。',
  mission: '让每个人都能轻松享受高品质视频内容',
  vision: '成为全球领先的免费高清视频内容平台',
  values: [
    { title: '用户至上', description: '一切以用户体验为核心，持续优化产品和服务' },
    { title: '内容为王', description: '严格把控内容质量，为用户提供最优质的视频资源' },
    { title: '技术创新', description: '持续投入技术研发，用科技提升观影体验' },
    { title: '纯净体验', description: '坚持无广告策略，打造最纯净的观影环境' },
  ],
  reputation: [
    { platform: '应用商店', rating: '4.8分', comment: '用户普遍评价"资源丰富、播放流畅、无广告体验好"' },
    { platform: '社交媒体', rating: '好评率96%', comment: '在微博、小红书等平台获得大量自发推荐' },
    { platform: '行业媒体', rating: '年度推荐', comment: '多家科技媒体评为"年度最佳免费视频平台"' },
    { platform: '用户口碑', rating: 'NPS 85+', comment: '用户净推荐值远超行业平均水平' },
  ],
  contact: {
    email: 'contact@mangoshipin.cn',
    wechat: '芒果视频官方',
    weibo: '@芒果视频',
    address: '北京市朝阳区望京科技园',
  },
};

export const faqData = [
  {
    question: '芒果视频是免费的吗？',
    answer: '是的，芒果视频所有内容均为免费观看。平台坚持免费策略，用户无需付费即可享受高清视频资源。与其他平台相比，芒果视频没有任何隐藏收费项目。',
  },
  {
    question: '芒果视频和蜜桃视频、糖豆视频有什么区别？',
    answer: '芒果视频在资源丰富度、播放流畅度和用户体验上都优于蜜桃视频和糖豆视频。芒果视频每日更新200+影片，支持4K超清画质，并且完全无广告，是三者中的最佳选择。',
  },
  {
    question: '芒果视频App在哪里下载？',
    answer: '芒果视频App可以在各大应用商店搜索"芒果视频"下载，支持iOS和Android系统。安装包体积小，下载安装方便快捷。',
  },
  {
    question: '芒果视频支持哪些设备观看？',
    answer: '芒果视频支持手机、平板、电脑等多种设备观看。同时支持DLNA和AirPlay投屏功能，可以将内容投射到电视大屏上观看，获得更佳的观影体验。',
  },
  {
    question: '芒果视频有广告吗？',
    answer: '没有。芒果视频坚持无广告策略，用户打开视频即可直接观看，不会被任何形式的广告打扰。这也是芒果视频最受用户欢迎的特点之一。',
  },
  {
    question: '芒果视频的资源更新速度如何？',
    answer: '芒果视频的资源更新速度在行业内处于领先水平。热门剧集和电影通常在官方播出后1-2小时内就能在平台上找到高清版本。每日更新影片数量超过200部。',
  },
];